import { SkylineErrorResponse } from '@/services/types';

import { ServiceError } from './service-error';

export class ServiceErrorFactory {
  /**
   * If the error is of type "Error" then either we encountered a JS error,
   * or the server/internet is down -- essentially, the browser is unable to
   * contact the server.
   *
   * Otherwise, we got an error response from the server, so parse it.
   * @param fnName
   * @param e
   */
  static createNew(
    fnName: string | undefined,
    e: SkylineErrorResponse | Error,
  ): ServiceError {
    if (e instanceof Error) {
      return this.createGenericNew(fnName, e);
    }
    return this.createErrorFromApiResponse(fnName, e);
  }

  private static createErrorFromApiResponse(
    fnName: string | undefined,
    e: SkylineErrorResponse,
  ) {
    return new ServiceError({
      fnName,
      errorCode: e.message,
      validationErrors: e.validationErrors,
      metadata: e.metadata,
    });
  }

  /**
   * Create ServiceError from Error
   * @param fnName
   * @param e
   * @private
   */
  private static createGenericNew(fnName: string | undefined, e: Error) {
    return new ServiceError({ fnName, message: e.message });
  }
}
